import React, { useState } from "react";
import { css } from "@emotion/react";
import { Button, Typography } from "@material-ui/core";
import Dropzone from "react-dropzone";
import { gql, useMutation } from "@apollo/client";

const cssParent = css``;

const MUT_UPLOAD = gql`
  mutation UploadBase64Image($base64Encoded: String!) {
    uploadBase64Image(base64Encoded: $base64Encoded) {
      success
      url
    }
  }
`;

enum State {
  idle,
  error,
  error_too_big,
  reading,
  uploading,
  complete,
}

const Messages = {
  [State.idle]: "Ready",
  [State.error]: "An error occurred",
  [State.error_too_big]: "Files cannot be larger than 50mb",
  [State.reading]: "Reading file...",
  [State.uploading]: "Uploading file...",
  [State.complete]: "Upload complete",
};

const toBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

interface ImageUploadProps {
  allowVideo?: boolean;
  onSuccess: (url: string) => void;
}

const ImageUpload = (p: ImageUploadProps) => {
  const allowVideo = p.allowVideo || false;
  const allowedFileTypes = allowVideo ? ["image/png", "image/jpeg", "image/gif", "video/mp4"] : ["image/png", "image/jpeg", "image/gif"];
  const [state, setState] = useState(State.idle);
  const [upload] = useMutation(MUT_UPLOAD);

  const handleFileDropped = (files: File[]) => {
    setState(State.reading);
    const file = files[0];
    if (file.size > 50 * 1024 * 1024) {
      setState(State.error_too_big);
      return;
    }

    toBase64(file)
      .then((base64) => {
        setState(State.uploading);
        upload({ variables: { base64Encoded: base64 } }).then((res) => {
          if (res.data.uploadBase64Image.success) {
            setState(State.complete);
            p.onSuccess(res.data.uploadBase64Image.url);
          } else {
            setState(State.error);
          }
        });
      })
      .catch((e) => {
        setState(State.error);
      });
    console.log(files);
  };
  const busy = state === State.reading || state === State.uploading;
  const message = Messages[state];

  return (
    <div css={cssParent}>
      <Typography align="center" variant="subtitle1">
        {message}
      </Typography>
      <div>
        {busy ? (
          <Button disabled fullWidth variant="contained">
            Upload
          </Button>
        ) : (
          <Dropzone
            onDrop={handleFileDropped}
            accept={allowedFileTypes}
          >
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <Button fullWidth variant="contained">
                  Upload
                </Button>
              </div>
            )}
          </Dropzone>
        )}
      </div>
    </div>
  );
};

export default ImageUpload;
